import React, {FC, PropsWithChildren, useCallback, useMemo} from 'react';

import {
  LinkNavigator,
  NavigationContext,
} from '../../../../libs/shared/ui/src/components/navigation/navigationContext';
import {useAppDispatch} from '../../../helpers/appReduxHelpers';
import {navigateToLinkAction} from '../../../store/stateless/navigationActions';

export const NavigationProvider: FC<PropsWithChildren<unknown>> = ({children}) => {
  const dispatch = useAppDispatch();

  const linkNavigator: LinkNavigator = useCallback(
    (link, shiftKey, navigationBlockerId) =>
      dispatch(navigateToLinkAction(link, shiftKey, navigationBlockerId)),
    [dispatch],
  );

  const context = useMemo(() => ({linkNavigator}), [linkNavigator]);
  return <NavigationContext.Provider value={context}>{children}</NavigationContext.Provider>;
};
